
import { Vue, Component, Prop } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user.store";
import { customRule } from "@/lib/rules/customRule.ts";

@Component({})
export default class LoginMixin extends Vue {
  @Prop()
  onLogin?: Function;

  @Prop({ default: "" })
  initialMailValue?: string;
  @Prop({ default: "" })
  initialPasswordValue?: string;
  @Prop()
  changeCard!: Function;

  success = false;
  failure = false;
  failureText = "Etwas ging schief. Prüfen Sie Ihre Eingaben!";
  successText = "Alles supi!";
  countdown = "";

  mail = this.initialMailValue || "";
  password = this.initialPasswordValue || "";

  //used for password checks in set/reset:
  password1 = "";
  password2 = "";
  isPasswordValid = false;
  setRequirementsFullfilled(isFullfilled: boolean) {
    this.isPasswordValid = isFullfilled;
  }
  get passwordRequirements() {
    return [customRule(this.isPasswordValid, "Die Anforderungen an das Passwort müssen erfüllt sein")];
  }
  get passwordRepeatRule() {
    return [customRule(this.password2 === this.password1, "Die Passwörter müssen übereinstimmen")];
  }
  get specialChars() {
    return "^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ ` =";
  }

  /*
   * Check if user is logged in by calling UserModule.getUserInfo();
   * if call fails, user is not logged in
   * if it works, user is logged in with valid information, and next page can be opened
   * called after form is submitted and once login component is mounted
   */
  async checkIfUserIsLoggedInAndRedirect() {
    if (UserModule.authAccessTokens?.accessToken) {
      try {
        await UserModule.getUserInfo();
        if (this.onLogin) {
          this.onLogin();
        } else {
          this.$router.push({ path: "/" });
        }
      } catch (error) {
        Vue.$log.info("User not signed in");
      }
    }
  }
  /*
   * sets success parameter to true, sets success text if given, starts countdown, executes callback after 3 seconds
   */
  setSuccessMessage(callback: Function, successText?: string) {
    if (successText) {
      this.successText = successText;
    }
    this.success = true;
    this.failure = false;
    setTimeout(() => callback(), 3000);
    setTimeout(() => (this.countdown = " (1)"), 2000);
    setTimeout(() => (this.countdown = " (2)"), 1000);
    this.countdown = " (3)";
  }
  /*
   * sets failure parameter to false, sets fil text if given
   */
  setFailMessage(text: string) {
    this.success = false;
    this.failure = true;
    this.failureText = text;
  }
  /**
   * adjusts height of login card, so that it doesn't fill the complete height
   */
  adjustLoginContainerHeight() {
    const loginContainer = document.getElementById("loginContainer");
    const loginInner = document.getElementById("loginInner");
    if (loginContainer && loginInner) {
      loginContainer.style.height = `${loginInner.clientHeight + 30}px`;
    }
  }
  mounted() {
    this.adjustLoginContainerHeight();
  }
  constructor() {
    super();
  }
}
